/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerManualRunAodRulesMutationRequest, AuditReportsTriggerManualRunAodRulesMutationResponse, AuditReportsTriggerManualRunAodRulesPathParams, AuditReportsTriggerManualRunAodRules401, AuditReportsTriggerManualRunAodRules403 } from "../models/AuditReportsTriggerManualRunAodRules";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsTriggerManualRunAodRules } from "../axios/auditReportsTriggerManualRunAodRules";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsTriggerManualRunAodRulesMutationKey = () => [{ url: '/audit-reports/v1/aod-rules/:id/manual-run' }] as const

export type AuditReportsTriggerManualRunAodRulesMutationKey = ReturnType<typeof auditReportsTriggerManualRunAodRulesMutationKey>

export function auditReportsTriggerManualRunAodRulesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditReportsTriggerManualRunAodRulesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditReportsTriggerManualRunAodRulesMutationKey()
        return mutationOptions<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, {id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return auditReportsTriggerManualRunAodRules(id, data, config)
          },
        })

}

/**
 * @description Triggers a manual AOD run for a specific AOD rule
 * @summary Trigger a manual AOD run for an AOD rule
 * {@link /audit-reports/v1/aod-rules/:id/manual-run}
 */
export function useAuditReportsTriggerManualRunAodRules<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, {id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditReportsTriggerManualRunAodRulesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsTriggerManualRunAodRulesMutationKey()

          const baseOptions = auditReportsTriggerManualRunAodRulesMutationOptions(config) as UseMutationOptions<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, {id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest}, TContext>
          

          return useMutation<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, {id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsTriggerManualRunAodRulesMutationResponse, ResponseErrorConfig<AuditReportsTriggerManualRunAodRules401 | AuditReportsTriggerManualRunAodRules403>, {id: AuditReportsTriggerManualRunAodRulesPathParams["id"], data: AuditReportsTriggerManualRunAodRulesMutationRequest}, TContext>
      
}